import * as React from 'react';

import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';

import * as style from './BlogCard.module.css';

const BlogCard = (props) => {
  const { title, img, link, clicked, date } = props;
  const MAX_LENGTH = 100;
  const trimmedTitle = title.substring(0, MAX_LENGTH);

  return (
    <Link to={`/blog/${link}/`} className={style.BlogCard} onClick={clicked}>
      <div className={style.topContainer}>
        <GatsbyImage
          image={img}
          alt={title}
          quality="100"
          webpoptions="true"
          placeholder="blurred"
        />
      </div>
      <div className={style.bottomContainer}>
        <div className={style.titleContainer}>
          {title.length > MAX_LENGTH ? (
            <p className="body1Emphasis">{`${title.substring(
              0,
              Math.min(trimmedTitle.length, trimmedTitle.lastIndexOf(' ')),
            )}...`}</p>
          ) : (
            <p className="body1Emphasis">{title}</p>
          )}
        </div>
        <div className={style.dateContainer}>
          <p className="p2">{date}</p>
        </div>
      </div>
    </Link>
  );
};

export default BlogCard;
